import axios from "axios";
import { API_BASE_URL } from "utils/api";

export const fetchClientsApi = async ({ page, limit, priority, search, sort, folderId }) => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);
  if (priority) params.append("priority", String(priority).toLowerCase());
  if (search) params.append("search", search);
  if (sort) params.append("sort", sort);

  const endpoint = folderId 
    ? `${API_BASE_URL}/clients/folder/${folderId}`
    : `${API_BASE_URL}/clients`;

  const response = await axios.get(`${endpoint}?${params.toString().replace(/%2B/g, "+")}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  return response?.data;
};
